import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { finalize } from 'rxjs/operators';
import { OrderDetails } from 'src/app/shared/models';
import { OrderConfirmation } from 'src/app/shared/models/order-confirmation.model';
import { FeedbackService, OrderService } from 'src/app/shared/services';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-find-orders',
  templateUrl: './find-orders.component.html',
  styleUrls: ['./find-orders.component.scss']
})
export class FindOrdersComponent implements OnInit {
  translatePath = 'public.tracking.find-orders.';
  resultList: Array<OrderConfirmation>;
  @ViewChildren('inputs') inputs: QueryList<ElementRef>;

  loading = false;
  noData = false;
  isAuthenticated: boolean;
  value: number;
  formArr: FormArray;
  constructor(
    private orderService: OrderService,
    private router: Router,
    private feedbackService: FeedbackService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private userService: UserService,
    private fb: FormBuilder
  ) {
    this.formArr = this.fb.array([
      new FormControl()
    ]);
  }
  ngOnInit(): void {
    let user = this.userService.getCurrentUser();
   this.isAuthenticated ? this.isAuthenticated = user.isAuthenticated : null;
  }

  addInput() {
    this.noData = false;
    this.formArr.push(new FormControl());
    setTimeout(() => {
      this.inputs.toArray()[this.formArr.length - 1].nativeElement.focus();
    }, 0);
  }

  remove(index: number) {
    this.formArr.removeAt(index);
  };

  isAvailableSearch() {
    return this.formArr.controls.length > 0 && this.formArr.controls.every(item => { return item.value });
  }

  search() {
    if (this.isAuthenticated) {
      this.searchOrders();
    } else {
      this.recaptchaV3Service.execute('')
        .subscribe(
          (token) => this.searchOrders(token),
          err => {
            this.feedbackService.handleError(err);
          }
        );
    }
  }

  getFormControl(control: AbstractControl): FormControl {
    return control as FormControl;
  }

  searchOrders(captchaValue = '') {
    this.loading = true;
    this.noData = false;
    this.orderService.searchOrders(this.formArr.value, captchaValue)
      .pipe(
        finalize(() => {
          this.loading = false
        })
      )
      .subscribe(
        res => {
          this.resultList = res;
          if (this.resultList.length == 1 && this.resultList[0].deliveryId) {
            this.router.navigate(['/public', 'tracking', this.resultList[0].deliveryId]);
          }
        },
        err => {
          this.resultList = [];
          this.feedbackService.handleError(err);
          this.value = this.formArr.controls[0].value;
          this.noData = true;
        }
      );
  }
}
